import { ChangeDetectorRef, Component, EventEmitter, Input, Output, SimpleChanges } from '@angular/core';
import * as _ from 'lodash';
import { NgIf, NgFor } from '@angular/common';
import { LtmsDataTableV2Component } from '../../../../shared/components/ltms-data-table-v2/ltms-data-table-v2.component';
import { LtmsLoaderComponent } from '../../../../shared/components/ltms-loader/ltms-loader.component';
import { OutboxInformationPanelComponent } from './outbox-information-panel/outbox-information-panel.component';

@Component({
  selector: 'app-outbox-detail-panel',
  templateUrl: './outbox-detail-panel.component.html',
  styleUrl: './outbox-detail-panel.component.scss',
  imports: [NgIf, NgFor, LtmsDataTableV2Component, LtmsLoaderComponent, OutboxInformationPanelComponent]
})
export class OutboxDetailPanelComponent {
  @Input() OutboxDetailsVisible!: boolean
  @Input() selectedChannelDetail: any;
  @Input() isRefreshing: boolean = false;
  @Input() showRefreshButton: boolean = false;
  @Input() isNotRespondedTab = false;
  @Output() close = new EventEmitter < void > ();
  @Output() refresh = new EventEmitter < void > ();

  tabs = [{ name: 'Channel Status', key: 'attempts' }, { name: 'Information', key: 'information' }];
  activeTab = this.tabs[0];
  @Input() brandDetails: any;
  @Input() outboxFeedData: any;
  informationFeedData: any = {};
  informationBrandDetails: any = {};
  informationFeedId = '';

  onChangeTab(tab: any) {
    this.activeTab = tab;
  }

  isDataLoaded = false;
  trialsData = []
  columns: any = []
  columns_header = ['Unformatted Attempt Number', 'Attempt Number', 'Attempt Date', 'Attempt Status']
  isCustomerNotifierServiceEnabled = false;
  is_request_expired = false;
  // tooltip config
  tooltipId: string = "channel-status-tooltip"
  tooltipTitle: string = ''
  tooltipValues: any[] = [];
  expiredAndServiceOFFMsg = "";
  notExpiredAndServiceOFFMsg = "";
  expiredAndServiceONMsg = "";
  notExpiredAndServiceONWithWaitMsg = "";
  notExpiredAndServiceONMsg = "";
  ifUserRatedWithoutTrialDetails = '';
  showWaitMsg = false;
  showTable: boolean = false;
  constructor(private cdr: ChangeDetectorRef) {}

  ngOnChanges(changes: SimpleChanges) {
    this.is_request_expired = false
    this.expiredAndServiceOFFMsg = "";
    this.notExpiredAndServiceOFFMsg = "";
    this.expiredAndServiceONMsg = "";
    this.notExpiredAndServiceONWithWaitMsg = "";
    this.notExpiredAndServiceONMsg = "";
    this.ifUserRatedWithoutTrialDetails = '';
    this.showWaitMsg = false;
    if (changes['OutboxDetailsVisible']?.currentValue && !changes['OutboxDetailsVisible']?.previousValue) {
      this.activeTab = this.tabs[0];
    }
    if (changes['selectedChannelDetail'] || changes['outboxFeedData'] || changes['brandDetails']) {
      this.prepareInformationData();
    }
    if (changes['selectedChannelDetail']) {
      this.isDataLoaded = false;
      if (changes['selectedChannelDetail'] && changes['selectedChannelDetail']['currentValue'] && changes['selectedChannelDetail']['currentValue']['trials']) {
        this.columns_header = ['Unformatted Attempt Number', 'Attempt Number', 'Attempt Date', 'Attempt Status']
        this.columns = []
        this.prepareTrialsData(changes['selectedChannelDetail']['currentValue'])
        // console.log(changes['selectedChannelDetail'])
      }
    }
    this.cdr.detectChanges();
  }
  prepareInformationData() {
    const request = this.selectedChannelDetail || {};
    const source = this.outboxFeedData || {};
    this.informationBrandDetails = this.brandDetails || (typeof Helpers !== 'undefined' ? Helpers.brandDetails : {}) || {};
    this.informationFeedData = source.feed
      ? source
      : {
          feed: request,
          tags: source.tags || request.tags || {},
          users: source.users || request.users || [],
          user: source.user || request.user || {}
        };
    this.informationFeedId = this.informationFeedData.feed?._id || '';
  }

  prepareTrialsData(requestData) {
    this.columns = [];
    this.trialsData = [];
    this.showTable = false;
    if ('trials' in requestData && requestData['trials'] && requestData['trials'].length > 0) {
      const trials = _.orderBy(requestData['trials'], ['attempt_date'], ['asc']);
      const data: any = []
      trials.forEach((trial) => {
        this.isCustomerNotifierServiceEnabled = true;
        let attempt_data: any = {};
        attempt_data['tooltip_text'] = {};

        const attemptNumber = trial.attempt.includes('on_demand')
          ? trial.attempt
            .replace('on_demand_', 'On Demand ')
            .replace('on_demand', 'On Demand')
          : parseInt(trial.attempt, 10);

        attempt_data['Unformatted Attempt Number'] = attemptNumber;

        attempt_data['Attempt Date'] = (trial['attempt_date']) ? trial['attempt_date'] : "NA";
        attempt_data['Attempt Status'] = (this.getMessageForRequestStatus(trial)['message']) ? this.getMessageForRequestStatus(trial)['message'] : "NA";
        if (this.getMessageForRequestStatus(trial)['tooltip_text']) {
          attempt_data['tooltip_text']['Attempt Status'] = (this.getMessageForRequestStatus(trial)['tooltip_text'])
        }
        if (trial && trial['channels']) {
          trial['channels'].forEach((channel) => {
            let channel_name = channel.channel.charAt(0).toUpperCase() + channel.channel.slice(1)

            let column_name_for_sent_status = channel_name + ' Sent Status';
            attempt_data[column_name_for_sent_status] = (this.getMessageForChannelStatus(channel)['message']) ? this.getMessageForChannelStatus(channel)['message'] : "NA";
            if (this.getMessageForChannelStatus(channel)['tooltip_text']) {
              attempt_data['tooltip_text'][column_name_for_sent_status] = (this.getMessageForChannelStatus(channel)['tooltip_text'])
            }

            let column_name_for_delivery_status = channel_name + ' Delivery Status';
            attempt_data[column_name_for_delivery_status] = (this.getMessageForDeliveryStatus(channel)['message']) ? this.getMessageForDeliveryStatus(channel)['message'] : "NA";
            if (this.getMessageForDeliveryStatus(channel)['tooltip_text']) {
              attempt_data['tooltip_text'][column_name_for_delivery_status] = (this.getMessageForDeliveryStatus(channel)['tooltip_text'])
            }

            if (!this.columns_header.includes(column_name_for_sent_status)) {
              this.columns_header.push(column_name_for_sent_status)
            }
            if (!this.columns_header.includes(column_name_for_delivery_status)) {
              this.columns_header.push(column_name_for_delivery_status)
            }
          })
        }
        this.columns_header.forEach((column) => {
          if (!(column in attempt_data)) {
            attempt_data[column] = 'NA';
          }
        });
        data.push(attempt_data)
      });
      this.prepareTableHeaders(this.columns_header)
      this.trialsData = data;
      this.isDataLoaded = true;
      setTimeout(() => this.showTable = true, 0);
    } else {
      this.trialsData = [];
      this.isDataLoaded = true;
      this.checkIfCustomerNotifierServiceIsRunning(requestData);
    }
  }


  getMessageForChannelStatus(channel): object {
    const return_object = {};
    if (channel && 'channel' in channel && 'attempted' in channel && 'sent' in channel) {
      let channel_name = channel.channel.charAt(0).toUpperCase() + channel.channel.slice(1)
      if (channel['attempted'] == true && channel['sent'] == true) {
        return_object['message'] = channel_name + ' sent successfully';

        // It might be a Provider failure or Invalid number/email
      } else if (channel['attempted'] == true && channel['sent'] == false) {
        return_object['message'] = channel_name + ' sent failed';
        if ('error_desc' in channel && this.getErrorDescription[channel.error_desc]) {
          return_object['tooltip_text'] = this.getErrorDescription[channel.error_desc];
        } else if ('error_string' in channel) {
          if (this.getErrorDescription[channel.error_string]) {
            return_object['tooltip_text'] = this.getErrorDescription[channel.error_string];
          } else if ('error_string_desc' in channel) {
            return_object['tooltip_text'] = channel['error_string_desc'];
          } else {
            return_object['tooltip_text'] = "Please check with Administrator"
          }
        } else {
          return_object['tooltip_text'] = channel['error'];
        }
      } else {
        return_object['message'] = channel_name + ' sent failed';
      }
    }
    return return_object;
  }

  getMessageForDeliveryStatus(channel): object {
    const return_object = {};
    if (channel && 'channel' in channel && 'attempted' in channel && 'sent' in channel) {
      let channel_name = channel.channel.charAt(0).toUpperCase() + channel.channel.slice(1)
      if (channel['attempted'] == true && channel['sent'] == true) {
        if (channel && 'channel' in channel && 'delivered' in channel && 'delivery_status' in channel && 'delivery_date' in channel) {
          if (channel['delivered'] == true && channel['delivery_status'] == 1) {
            return_object['message'] = channel_name + ' delivered successfully.';
          } else if (channel['delivered'] == false && channel['delivery_status'] !== 1) {
            return_object['message'] = channel_name + ' delivery failed.';
            if ('original_dlr_status' in channel) {
              return_object['tooltip_text'] = channel_name + ' delivery failed due to a ' + channel['original_dlr_status'];
            }
          } else {
            return_object['message'] = channel_name + ' delivery failed';
          }
        } else if (channel && 'channel' in channel && 'delivered' in channel && 'sent' in channel) {
          if (channel['delivered'] == true && channel['sent'] == true) {
            return_object['message'] = channel_name + ' delivered successfully.';
          } else {
            return_object['message'] = channel_name + ' delivery failed.';
          }
        } else {
          return_object['message'] = "DLR not received.";
          return_object['tooltip_text'] = "Awaiting report or not yet integrated.";
        }
      } else {
        return_object['message'] = 'NA'
      }
    } else {
      return_object['message'] = 'NA'
    }
    return return_object;
  }

  getMessageForRequestStatus(trial): object {
    const return_object = {};
    if (trial && trial['error'] && trial['error_type']) {
      return_object['message'] = "Failed";
      return_object['tooltip_text'] = (this.getErrorDescription[trial.error]) ? this.getErrorDescription[trial.error] : trial['error_type']
    } else if (trial && trial['error'] || trial['error_type']) {
      return_object['message'] = "Failed";
      return_object['tooltip_text'] = (this.getErrorDescription[trial.error]) ? this.getErrorDescription[trial.error] : trial['error_type']
    } else {
      return_object['message'] = "Success";
    }
    if (!trial.hasOwnProperty("channels") && !trial.hasOwnProperty("error") && !trial.hasOwnProperty("error_type")) {
      return_object['message'] = "Not configured or no channel process is available for this attempt.";
    }
    return return_object;
  }

prepareTableHeaders(col) {
  let col_order = 0;
  const defaultSortKey = 'Attempt Date';
  if (col && col.length > 0) {
    col.forEach((column) => {
      const columnNameObject: any = {};
      col_order += 1;
      columnNameObject['header'] = column;

      // ✅ Force Attempt Number to sort by Unformatted Attempt Number
      if (column === 'Attempt Number') {
        columnNameObject['dataKey'] = 'Unformatted Attempt Number'; // sort key
        columnNameObject['displayKey'] = 'Attempt Number'; // UI key
        columnNameObject['dataType'] = 'number';
      } else {
        columnNameObject['dataKey'] = column;
        columnNameObject['displayKey'] = column;
        columnNameObject['dataType'] = column === 'Attempt Date' ? 'date' : 'string';
      }

      columnNameObject['order'] = col_order;
      columnNameObject['width'] = '20%';
      columnNameObject['ellipsisEnabled'] = true;
      columnNameObject['is_deviation_enabled'] = false;
      columnNameObject['enabled'] = true;
      columnNameObject['style'] = {
        headerTextAlign: 'left',
        cellTextAlign: 'left',
      };

      // ✅ Enable sorting only for Attempt Number & Attempt Date
      if (column === 'Attempt Number' || column === 'Attempt Date') {
        columnNameObject['sortingEnabled'] = false;
        columnNameObject['sortable'] = true;

        if (column === defaultSortKey) {
          columnNameObject['isColumnSorted'] = true;
          columnNameObject['isSelected'] = true;
          columnNameObject['sortDirection'] = 'asc'; // default ascending
        } else {
          columnNameObject['isColumnSorted'] = false;
          columnNameObject['isSelected'] = false;
          columnNameObject['sortDirection'] = null;
        }
      } else {
        columnNameObject['sortingEnabled'] = false;
        columnNameObject['sortable'] = false;
        columnNameObject['isColumnSorted'] = false;
        columnNameObject['isSelected'] = false;
        columnNameObject['sortDirection'] = null;
      }

      // 🚫 Skip pushing hidden field (Unformatted Attempt Number)
      if (column !== 'Unformatted Attempt Number') {
        this.columns.push(columnNameObject);
      }
    });
  }
}


  checkIfCustomerNotifierServiceIsRunning(requestData) {
    if (Helpers.brandDetails && Helpers.brandDetails['_id']) {
      const feedbacks = _.get(Helpers.brandDetails, 'conversation_config.feedbacks', {});
      const date_limit_interval = _.get(feedbacks, 'date_limit_interval', '5');
      this.is_request_expired = false;
      let is_CFRA_data = false;
      let diffInMs = 0
      if (requestData && !requestData['feedback_request_date']) {
        is_CFRA_data = false;
        const today = new Date();
        const oldDate = new Date(requestData['created_date']);
        // Calculate the difference in milliseconds
        diffInMs = today.getTime() - oldDate.getTime();
        // Convert to days
        const diffInDays = Math.floor(diffInMs / (1000 * 60 * 60 * 24));
        if (diffInDays >= Number(date_limit_interval)) {
          this.is_request_expired = true;
        } else {
          this.is_request_expired = false;
        }
      } else {
        is_CFRA_data = true;
      }
      if (!_.isEmpty(feedbacks) && 'enable_notifications' in feedbacks && feedbacks['enable_notifications'] == false) {
        this.isCustomerNotifierServiceEnabled = false;
        if (this.is_request_expired) {
          this.expiredAndServiceOFFMsg = "The Notification Service has stopped, and this request has expired. It will no longer be picked up by the Customer Notifier Service for processing."
          // console.log(this.expiredAndServiceOFFMsg)
        } else {
          this.notExpiredAndServiceOFFMsg = "The Notification Service has been stopped. If you need to send communication to the customer/user, please contact the Administrator."
          // console.log(this.notExpiredAndServiceOFFMsg)
        }
      } else {
        this.isCustomerNotifierServiceEnabled = true;
        if (this.is_request_expired) {
          this.expiredAndServiceONMsg = "This request has expired and will no longer be picked up by the Customer Notifier Service for processing."
          // console.log(this.expiredAndServiceONMsg);
        } else {
          // within 30 min 
          if (!is_CFRA_data && diffInMs < 1800000) {
            this.showWaitMsg = true;
            this.notExpiredAndServiceONWithWaitMsg = "Please wait for some time to process the request.";
            // console.log(this.notExpiredAndServiceONWithWaitMsg)
          } else if (!is_CFRA_data) {
            this.notExpiredAndServiceONMsg = "It's taking longer than usual. If the status still doesn't change, please refresh the page or contact the Administrator."
            // console.log(this.notExpiredAndServiceONMsg);
          } else if (is_CFRA_data && 'trials' in requestData && requestData['trials'].length == 0) {
            this.ifUserRatedWithoutTrialDetails = "No data available"
          }
        }
      }
    }
  }

  // close the side panel 
  closeOutboxDetailPanel() {
    this.close.emit();
  }

  refreshOutboxDetailPanel() {
    if (this.isRefreshing) {
      return;
    }
    this.refresh.emit();
  }

  static readonly getErrorDescription: Record<string, string> = {
    "CN_ERROR_NOTIFY_CHANNEL_NONE": "Notification channel is none",
    "CN_ERROR_CUSTOMER_ID_INVALID": "Invalid Customer_id",
    "CN_ERROR_DEDUPLICATION_OBJECT_NULL_001": "Litmus Deduplication object or class name is null",
    "CN_ERROR_DEDUPLICATION_TAG_FIELDS_MISSING_001": "Deduplication brand tag fields missing",
    "CN_ERROR_DEDUPLICATION_TAG_FIELDS_EMPTY_002": "Deduplication brand tag fields are empty",
    "CN_ERROR_DEDUPLICATION_CFR_TAG_FIELDS_MISSING_003": "Deduplication field is missing in cfr",
    "CN_ERROR_DEDUPLICATION_OTHERS_RESPONDED_001": "Customer has responded within the dedupe interval",
    "CN_ERROR_DEDUPLICATION_OTHERS_REQUESTED_TRIAL_101": "Eureka Customer has requested with the dedupe field(s) for trial 1",
    "CN_ERROR_DEDUPLICATION_OTHERS_REQUESTED_TRIAL_102": "Eureka Customer has requested with the dedupe field(s) for trial 2",
    "CN_ERROR_DEDUPLICATION_OTHERS_REQUESTED_TRIAL_103": "Eureka Customer has requested with the dedupe field(s) for trial 3",
    "CN_ERROR_DEDUPLICATION_OTHERS_REQUESTED_TRIAL_104": "Eureka Customer has requested with the dedupe field(s) for trial 4",
    "CN_ERROR_DEDUPLICATION_OTHERS_REQUESTED_TRIAL_105": "Eureka Customer has requested with the dedupe field(s) for trial 5",
    "CN_ERROR_DEDUPLICATION_OTHERS_REQUESTED_TRIAL_106": "Eureka Customer has requested with the dedupe field(s) for trial 6",
    "CN_ERROR_DEDUPLICATION_OTHERS_REQUESTED_TRIAL_107": "Eureka Customer has requested with the dedupe field(s) for trial 7",
    "CN_ERROR_DEDUPLICATION_CONFIGURABLE_RESPONDED_001": "For configured dedup check Customer has responded within the dedupe interval with dedup field(s)",
    "CN_ERROR_DEDUPLICATION_CONFIGURABLE_RESPONDED_002": "While validating For configured dedup check Customer has responded within the dedupe interval with exception info",
    "CN_ERROR_DEDUPLICATION_ACCOUNT_NULL_101": "Account level depup check either account is null",
    "CN_ERROR_DEDUPLICATION_ACCOUNT_BRAND_LIST_MISSING_102": "Account level depup check brands list is not present in accounts",
    "CN_ERROR_DEDUPLICATION_ACCOUNT_CUSTOMER_ID_TAG_MISSING_103": "Account level depup check tag_customer_id is not present for user",
    "CN_ERROR_DEDUPLICATION_ACCOUNT_RESPONDED_104": "Account level depup check Customer has responded within the dedupe interval",
    "CN_ERROR_DEDUPLICATION_ACCOUNT_106": "Error occured while checking deduplication request from customer feedback request archive",
    "CN_ERROR_DEDUPLICATION_DEFAULT_RESPONDED_001": "Default dedup Customer has responded within the dedupe interval with dedup field(s)",
    "CN_ERROR_DEDUPLICATION_DEFAULT_RESPONDED_002": "Exception occured while checking default dedup for Customer has responded  with exception info",
    "CN_ERROR_DEDUPLICATION_SUBACCOUNT_MISSING_101": "Sub-account level depup check sub-account is not present in cfr request",
    "CN_ERROR_DEDUPLICATION_SUBACCOUNT_BRANDID_LIST_MISSING_102": "Sub-account level depup check eiither sub-account is not present or brand_ids list in sub-account document",
    "CN_ERROR_DEDUPLICATION_SUBACCOUNT_BRANDID_LIST_NOT_AVAILABLE_103": "Sub-account level depup check brands list is not present in accounts",
    "CN_ERROR_DEDUPLICATION_SUBACCOUNT_USER_CUSTOMER_ID_TAG_MISSING_104": "Sub-account level depup check tag_customer_id is not present for user",
    "CN_ERROR_DEDUPLICATION_SUBACCOUNT_RESPONDED_105": "Sub-account level depup check Customer has responded within the dedupe interval",
    "CN_ERROR_DEDUPLICATION_SUBACCOUNT_RESPONDED_106": "Error occured while checking sub-account deduplication while checking Customer has responded within the de-dupe interval with error info",
    "CN_ERROR_DEDUPLICATION_005": "Error occured while checking deduplication with error info",
    "CN_ERROR_BRAND_DYNAMIC_TEMPLATE_TAG_MISSING": "Dynamic template tags not available in the brands",
    "CN_ERROR_DYNAMIC_TEMPLATE_TAG_CLASS_NOT_FOUND": "Dynamic template class not found on brand",
    "CN_ERROR_DYNAMIC_TEMPLATE_TAG_INSTANTIATION_EXCEPTION": "Dynamic template class instantiation exception",
    "CN_ERROR_DYNAMIC_TEMPLATE_TAG_ILLEGALACCESS_EXCEPTION": "Dynamictemplate class illegalAccess exception",
    "CN_ERROR_DYNAMIC_TEMPLATE_TAG_EXCEPTION": "Dynamic template class generic exception, exception with error info",
    "CN_ERROR_DYNAMIC_TEMPLATE_TAG_NOT_FOUND_ON_CFR": "Brand dynamic tags not found on request",
    "CN_ERROR_DYNAMIC_TEMPLATE_NOT_FOUND": "Dynamic email template not found",
    "CN_ERROR_MULTIPLE_DYNAMIC_TEMPLATE_FOUND": "Multiple dynamic templates found is invalid",
    "CN_ERROR_EMAIL_INCORRECT_MAIL_ID": "Incorrect Email",
    "CN_ERROR_EMAIL_INVALID_MAIL_ID": "Invalid Email",
    "CN_ERROR_DEDUPLICATION_DEFAULT_NOTIFICATION_COUNT_101": "For default deduplication check Litmus Number of allowed attempts(notification count) over",
    "CN_ERROR_DEDUPLICATION_CONFIGURABLE_NOTIFICATION_COUNT_101": "For configurable deduplication check Litmus Number of allowed attempts(notification count) over",
    "CN_ERROR_DEDUPLICATION_ACCOUNT_NOTIFICATION_COUNT_101": "For account deduplication check Litmus Number of allowed attempts(notification count) over",
    "CN_ERROR_DEDUPLICATION_CONFIGURABLE_ACCOUNT_NOTIFICATION_COUNT_101": "For account deduplication check Litmus Number of allowed attempts(notification count) over",
    "CN_ERROR_DEDUPLICATION_SUBACCOUNT_NOTIFICATION_COUNT_101": "For sub-account deduplication check Litmus Number of allowed attempts(notification count) over",
    "CN_ERROR_DEDUPLICATION_DEFAULT_REQUEST_COUNT_101": "For default deduplication check Litmus Number of allowed attempts(request count) over",
    "CN_ERROR_DEDUPLICATION_CONFIGURABLE_REQUEST_COUNT_101": "For configurable deduplication check Litmus Number of allowed attempts(request count) over",
    "CN_ERROR_DEDUPLICATION_ACCOUNT_REQUEST_COUNT_101": "For account deduplication check Litmus Number of allowed attempts(request count) over",
    "CN_ERROR_DEDUPLICATION_SUBACCOUNT_REQUEST_COUNT_101": "For sub-account deduplication check Litmus Number of allowed attempts(request count) over",
    "CN_ERROR_DEDUPLICATION_REQUEST_COUNT_102": "For deduplication check Litmus Number of allowed attempts(request count) is negative in either shop, brand, litmus-settings",
    "CN_ERROR_DEDUPLICATION_DEFAULT_NOTIFICATION_COUNT_102": "For default deduplication check Litmus Number of allowed attempts(notification count) is negative",
    "CN_ERROR_DEDUPLICATION_ACCOUNT_REQUEST_COUNT_102": "For account deduplication check Litmus Number of allowed attempts(request count) is negative",
    "CN_ERROR_DEDUPLICATION_ACCOUNT_NOTIFICATION_COUNT_102": "For account deduplication check Litmus Number of allowed attempts(notification count) is negative",
    "CN_ERROR_DEDUPLICATION_SUBACCOUNT_REQUEST_COUNT_102": "For sub-account deduplication check Litmus Number of allowed attempts(request count) is negative",
    "CN_ERROR_DEDUPLICATION_SUBACCOUNT_NOTIFICATION_COUNT_102": "For sub-account deduplication check Litmus Number of allowed attempts(notification count) is negative",
    "CN_ERROR_DEFAULT_SINGLE_NOTIFICATION_001": "In Default deduplication check, Single notification per day",
    "CN_ERROR_ACCOUNT_SINGLE_NOTIFICATION_001": "In Account deduplication check Single notification per day",
    "CN_ERROR_SUBACCOUNT_SINGLE_NOTIFICATION_001": "Sub-account Single notification per day",
    "CN_ERROR_SMS_INCORRECT_PHONE_NUMBER": "Incorrect phone number",
    "CN_ERROR_SMS_INVALID_PHONE_NUMBER": "Invalid phone number",
    "CN_ERROR_SMS_TEMPLATE_TAGS_MISSING": "Tags missing in sms template with tag names",
    "CN_ERROR_SMS_TEMPLATE_001": "Generic exception occured in generating/replacing template variables for sms",
    "CN_ERROR_EMAIL_TEMPLATE_TAGS_MISSING": "Tags missing in email template with tag names",
    "CN_ERROR_EMAIL_TEMPLATE_001": "Generic exception occured in generating/replacing template variables for email",
    "CN_USER_UNSUSCRIBED": "User opted for unsuscription",
    "CN_ERROR_PROVIDER_SMS_ACL_RESPONSE_INVALID": "Exception occurs from ACL provider with response with response info",
    "CN_ERROR_PROVIDER_SMS_ACL_NULL_RESPONSE": "Exception occurs from ACL provider with response code",
    "CN_ERROR_PROVIDER_SMS_ACL": "Generic exception occurs for ACL sms provider with exception info",
    "CN_ERROR_PROVIDER_SMS_BSMART_STATUS_CODE_NON_ZERO": "Exception occurs from BSMART provider with response code is non zero with status code",
    "CN_ERROR_PROVIDER_SMS_BSMART_NULL_RESPONSE": "Exception occurs from BSMART provider with response code",
    "CN_ERROR_PROVIDER_SMS_BSMART": "Generic exception occurs for BSMART sms provider with exception info",
    "CN_ERROR_PROVIDER_SMS_DETOKENIZED": "Exception occurs from DETOKENIZED sms provider with exception info",
    "CN_ERROR_PROVIDER_SMS_GAHARUSATURN_RESPONSE_HEAD": "Exception occurs from GAHARUSATURN sms provider either response head is null or response code is empty or not equal to 1",
    "CN_ERROR_PROVIDER_SMS_GAHARUSATURN_NULL_RESPONSE": "Exception occurs from GAHARUSATURN sms provider with null/empty response",
    "CN_ERROR_PROVIDER_SMS_GAHARUSATURN": "Generic exception occurs for GAHARUSATURN sms provider with exception info",
    "CN_ERROR_PROVIDER_SMS_ICUBES_NOT_SUCCESS": "Exception occurs from ICUBES sms provider response not success(note: iCubes does not return any message id in the response)",
    "CN_ERROR_PROVIDER_SMS_ICUBES_STATUS_NOT_200": "Exception occurs from ICUBES sms provider response status is not 200 with status(note: iCubes does not return any message id in the response)",
    "CN_ERROR_PROVIDER_SMS_ICUBES_STATUS_NOT_AVAILABLE": "Exception occurs from ICUBES sms provider json response/response status is not avilable(note: iCubes does not return any message id in the response)",
    "CN_ERROR_PROVIDER_SMS_ICUBES_RESPONSE_NOT_AVAILABLE": "Exception occurs from ICUBES sms provider response is NULL or EMPTY(note: iCubes does not return any message id in the response)",
    "CN_ERROR_PROVIDER_SMS_ICUBES_RESPONSE_CODE": "Exception occurs from ICUBES sms provider response code is not 200 with response code(note: iCubes does not return any message id in the response)",
    "CN_ERROR_PROVIDER_SMS_ICUBES_MISSING_CONFIGURATION_PARAMS": "Exception occurs from ICUBES sms provider while getting configuration parameters from sms provider collection [authorization_token, message_type, trigger_sms_id, list_id](note: iCubes does not return any message id in the response)",
    "CN_ERROR_PROVIDER_SMS_ICUBES": "Generic exception occurs in ICUBES sms provider with exception info(note: iCubes does not return any message id in the response)",
    "CN_ERROR_PROVIDER_SMS_INFOBIP_RESPONSE_NOT_AVAILABLE": "Exception occurs from INFOBIP sms provider response is NULL or EMPTY",
    "CN_ERROR_PROVIDER_SMS_INFOBIP_MISSING_CONFIGURATION_PARAMS": "Exception occurs from INFOBIP sms provider configuration from sms_provider collection is missing",
    "CN_ERROR_PROVIDER_SMS_INFOBIP_MISSING_CONFIGURATION_PARAMS_NOTIFY_URL_FIELD": "Exception occurs from INFOBIP sms provider configuration from sms_provider collection notify_url field is missing",
    "CN_ERROR_PROVIDER_SMS_INFOBIP_MISSING_CONFIGURATION_PARAMS_NOTIFY_CONTENT_TYPE_FIELD": "Exception occurs from INFOBIP sms provider configuration from sms_provider collection notify_content_type field is missing",
    "CN_ERROR_PROVIDER_SMS_INFOBIP_MISSING_CONFIGURATION_PARAMS_USERNAME_PASSWORLD_FIELD": "Exception occurs from INFOBIP sms provider configuration from sms_provider collection username and/or passworld field is missing",
    "CN_ERROR_PROVIDER_SMS_INFOBIP_MISSING_RESPONSE_MESSAGEID_FIELD": "Exception occurs from INFOBIP sms provider response messageId field is missing",
    "CN_ERROR_PROVIDER_SMS_INFOBIP_RESPONSE_MESSAGE_SIZE_ZERO": "Exception occurs from INFOBIP sms provider response message size is zero",
    "CN_ERROR_PROVIDER_SMS_INFOBIP_RESPONSE_MESSAGES_MISSING": "Exception occurs from INFOBIP sms provider response messages missing or NULL",
    "CN_ERROR_PROVIDER_SMS_INFOBIP_NULL_RESPONSE": "Exception occurs from INFOBIP sms provider having NULL response",
    "CN_ERROR_PROVIDER_SMS_INFOBIP": "Generic exception occurs in INFOBIP sms provider class with exception info",
    "CN_ERROR_PROVIDER_SMS_KOTAK_RESPONSE_INVALID": "Exception occurs from kotak email provider due to NULL or EMPTY  or invalid response",
    "CN_ERROR_PROVIDER_SMS_KOTAK_RESPONSE": "Exception occurs from kotak sms provider due to generic exception with exception info",
    "CN_ERROR_PROVIDER_SMS_KOTAK_TAG_CUSTOMER_ID_MISSING": "Exception occurs from kotak sms provider due to missing tag_customer_id in user document",
    "CN_ERROR_PROVIDER_SMS_MGAGE_RESPONSE": "Exception from mgage SMS provider with response code: [responseCode] not success with response",
    "CN_ERROR_PROVIDER_SMS_MGAGE_NULL_RESPONSE": "Exception occurs from mgage sms provider having NULL response",
    "CN_ERROR_PROVIDER_SMS_MGAGE": "Exception occurs from mgage sms provider with exception info",
    "CN_ERROR_PROVIDER_SMS_MVAAYOO_STATUS_CODE_NULL": "Exception occurs from mvaayoo sms provider due to status code is NULL, EMPTY or status is not zero",
    "CN_ERROR_PROVIDER_SMS_MVAAYOO_RESPONSE_NULL": "Exception occurs from mvaayoo sms provider due to response is NULL, EMPTY",
    "CN_ERROR_PROVIDER_SMS_MVAAYOO": "Exception occurs from mvaayoo sms provider with exception info",
    "CN_ERROR_PROVIDER_SMS_NETCORE_RESPONSE_CODE": "Exception from netcore SMS provider with response code: [responseCode] expected 200 with response code",
    "CN_ERROR_PROVIDER_SMS_NETCORE_UNSUPPORTEDENCODINGEXCEPTION": "Exception from netcore sms provider with UnsupportedEncodingException",
    "CN_ERROR_PROVIDER_SMS_NETCORE_PARSERCONFIGURATIONEXCEPTION": "Exception from netcore sms provider with ParserConfigurationException",
    "CN_ERROR_PROVIDER_SMS_NETCORE_SAXEXCEPTION": "Exception from netcore sms provider with SAXException",
    "CN_ERROR_PROVIDER_SMS_NETCORE_IOEXCEPTION": "Exception from netcore sms provider with IOException",
    "CN_ERROR_PROVIDER_SMS_NETCORE": "General exception from netcore sms provider with exception message",
    "CN_ERROR_PROVIDER_SMS_NULL": "Exception from null sms sender",
    "CN_ERROR_PROVIDER_SMS_ONSTAR_MISSING_MESSAGE-ID_FIELD": "Exception occurs from onstar sms provider response message-id field is missing",
    "CN_ERROR_PROVIDER_SMS_ONSTAR_RESPONSE_STATUS_EMPTY": "Exception occurs from onstar sms provider response status is empty",
    "CN_ERROR_PROVIDER_SMS_ONSTAR_RESPONSE_STATUS": "Exception occurs from onstar sms provider response status is not zero with response status",
    "CN_ERROR_PROVIDER_SMS_ONSTAR_RESPONSE_MESSAGES_EMPTY": "Exception occurs from onstar sms provider expected response messages missing (response array list size found zero(0))",
    "CN_ERROR_PROVIDER_SMS_ONSTAR_RESPONSE_MESSAGES_MISSING": "Exception occurs from onstar sms provider expected response messages missing",
    "CN_ERROR_PROVIDER_SMS_ONSTAR_RESPONSE_NULL": "Exception occurs from onstar sms provider due to response is NULL after json parse",
    "CN_ERROR_PROVIDER_SMS_ONSTAR": "General exception from onstar sms provider with exception info",
    "CN_ERROR_PROVIDER_SMS_ROUTEMOBILE_DND_STATUS_CODE_1032_1042": "Customize DND from routemobile sms provider due to response code 1032 or 1042",
    "CN_ERROR_PROVIDER_SMS_ROUTEMOBILE_STATUS_CODE": "Exception from routemobile sms provider, response code should be 1701with status code",
    "CN_ERROR_PROVIDER_SMS_ROUTEMOBILE_RESPONSE_NULL": "Exception occurs from routemobile sms provider due to response is NULL, EMPTY with response code",
    "CN_ERROR_PROVIDER_SMS_ROUTEMOBILE": "General exception from routemobile sms provider with exception info",
    "CN_ERROR_PROVIDER_SMS_GUPSHUP_STATUS_NOT_SUCCESS": "Exception occurs from gupshup sms provider due to response status code is not success with status code",
    "CN_ERROR_PROVIDER_SMS_GUPSHUP_RESPONSE_NULL": "Exception occurs from gupshup sms provider due to response is NULL, EMPTY",
    "CN_ERROR_PROVIDER_SMS_GUPSHUP_RESPONSE_PARSING": "Exception occurs from gupshup sms provider due to response parsing",
    "CN_ERROR_PROVIDER_SMS_GUPSHUP": "General exception from gupshup sms provider with exception info",
    "CN_ERROR_PROVIDER_SMS_TITAN_STATUS_NULL": "Exception occurs from titan sms provider status is null",
    "CN_ERROR_PROVIDER_SMS_TITAN_STATUS_CODE": "Exception occurs from titan sms provider status code is not 200 with status",
    "CN_ERROR_PROVIDER_SMS_TITAN_RESPONSE_NULL": "Exception occurs from titan sms provider response is null or empty",
    "CN_ERROR_PROVIDER_SMS_TITAN_SMS_URL_MISSING": "Exception occurs from titan sms provider sms url is missing from sms_providers collection",
    "CN_ERROR_PROVIDER_SMS_TITAN_BRAND_SMS_TAG_MISSING": "Exception occurs from titan sms provider, tag field is missing from brand object",
    "CN_ERROR_PROVIDER_SMS_TITAN_BRAND_TAG_FIELD_MISSING": "Exception occurs from titan sms provider sms tags is missing from brand object required tag names: sms_tag1, sms_tag2, and sms_dlr_req",
    "CN_ERROR_PROVIDER_SMS_TITAN": "General exception from titan sms provider with exception info",
    "CN_ERROR_PROVIDER_EMAIL_DETOKENIZED": "Exception occurs from DETOKENIZED email provider with exception info",
    "CN_ERROR_PROVIDER_EMAIL_KOTAK_RESPONSE_INVALID": "Exception occurs from kotak email provider due to NULL or EMPTY  or invalid response or generic",
    "CN_ERROR_PROVIDER_EMAIL_KOTAK_TAG_CUSTOMER_ID_MISSING": "Exception occurs from kotak email provider due to missing tag_customer_id in user document",
    "CN_ERROR_PROVIDER_EMAIL_MAILGUN": "Exception occurs from mailgun email provider with exception name with exception name",
    "CN_ERROR_PROVIDER_EMAIL_SMTP_NOSUCHPROVIDEREXCEPTION": "Exception occurs from SMTP Email provider with NoSuchProvider Exception while sending email",
    "CN_ERROR_PROVIDER_EMAIL_SMTP_MESSAGINGEXCEPTION": "Exception occurs from SMTP Email provider with messaging exception",
    "CN_ERROR_PROVIDER_EMAIL_SMTP": "Exception occurs from SMTP Email provider with exception info",
    "CN_ERROR_PROVIDER_EMAIL_TITAN_EMAIL_ADDRESS_NULL": "Exception occurs from titan email provider with, email address is null or empty",
    "CN_ERROR_PROVIDER_EMAIL_TITAN_AUTHTOKEN_NULL": "Exception occurs from titan email provider with, authentication token is null",
    "CN_ERROR_PROVIDER_EMAIL_TITAN_EMAIL_URL_NULL": "Exception occurs from titan email provider email url is missing from sms_providers collection",
    "CN_ERROR_PROVIDER_EMAIL_TITAN_FEEDBACK_URL_NULL": "Exception occurs from titan email provider feedback url is missing on customer feedback request",
    "CN_ERROR_PROVIDER_EMAIL_TITAN_RESPONSE_NULL": "Exception occurs from titan email provider NPS-IMC API response found null",
    "CN_ERROR_PROVIDER_EMAIL_TITAN_JSON_RESPONSE_NULL": "Exception occurs from titan email provider XTMAILING RESPONSE is null after converting response to json object",
    "CN_ERROR_PROVIDER_EMAIL_TITAN_RESPONSE_ERROR_NPS_IMC_API": "Exception occurs from titan email provider Error in NPS-IMC API response or error string if available",
    "CN_ERROR_PROVIDER_EMAIL_TITAN_RESPONSE_STATUS": "Exception occurs from titan email provider non zero  with response status",
    "CN_ERROR_PROVIDER_EMAIL_TITAN_WEB_SERVICE_RESPONSE_NULL": "Exception occurs from titan email provider web service call response is empty",
    "CN_ERROR_PROVIDER_EMAIL_TITAN_WEB_SERVICE_RESPONSE_CODE_NOT_NULL": "Exception occurs from titan email provider web service call response code is not 200 or 202 and response is not null/responnse code",
    "CN_ERROR_PROVIDER_EMAIL_TITAN_WEB_SERVICE_TAG_EMAIL_CAMPAIGN_ID_MISSING": "Exception occurs from titan email provider web service email_campaign_id tag is missing",
    "CN_ERROR_PROVIDER_EMAIL_TITAN_AUTH_SERVICE_BRAND_TAGS_OBJECT_MISSING": "Exception occurs from titan email provider web service from auth tags for brands is missing",
    "CN_ERROR_PROVIDER_EMAIL_TITAN_AUTH_WEB_SERVICE_RESPONSE_CODE": "Exception occurs from titan email provider web service call from auth response code is not 200 or 202 with response code",
    "CN_ERROR_PROVIDER_EMAIL_TITAN": "Generic exception occurs from titan email provider with exception info",
    "CN_ERROR_PROVIDER_IVR_SOLUTIONSIFINI_STATUS_NOT_200": "Exception occurs from solutionsinfifni ivr provider due to status code is not 200",
    "CN_ERROR_PROVIDER_IVR_SOLUTIONSIFINI_RESPONSE_NULL": "Exception occurs from solutionsinfifni ivr provider due to response is NULL, EMPTY",
    "CN_ERROR_PROVIDER_IVR_SOLUTIONSIFINI": "Exception occurs from solutionsinfini ivr provider with exception info",
    "CN_ERROR_WHATSAPP_INCORRECT_WHATSAPP_NUMBER": "Incorrect WhatsApp number",
    "CN_ERROR_WHATSAPP_CFR_OPTIN": "Optin is set to false through notification request",
    "CN_ERROR_WHATSAPP_BRAND_OPTIN": "Optin is set to false through brand settings",
    "CN_ERROR_WHATSAPP_TEMPLATE_NULL": "WhatsApp template not found",
    "CN_ERROR_WHATSAPP_INVALID_WHATSAPP_NUMBER": "Invalid WhatsApp number",
    "CN_ERROR_WHATSAPP_PROVIDER_002": "Username-password missing for provider",
    "CN_ERROR_WHATSAPP_PROVIDER_001": "Params object missing for WhatsApp provider",
    "CN_ERROR_WHATSAPP_PROVIDER_003": "ACL provider whatsapp language code is missing",
    "CN_ERROR_WHATSAPP_PROVIDER_004": "WhatsApp template-id missing",
    "CN_ERROR_WHATSAPP_TEMPLATE_INVALID_002": "Template invalid while sending to provider(found -- in template text",
    "CN_ERROR_WHATSAPP_TEMPLATE_TAGS_MISSING": "Template tag not found in the notification request",
    "CN_ERROR_WHATSAPP_TEMPLATE_PARAMETER_MISSING": "Template parameter missing ",
    "CN_ERROR_WHATSAPP_TEMPLATE_001": "Generic exception occurs while template transformation",
    "CN_ERROR_PROVIDER_WHATSAPP_ACL_RESPONSE_CODE_INVALID": "Invalid response code from acl WhatsApp provider",
    "CN_ERROR_PROVIDER_WHATSAPP_ACL_FAILURE": "Failure in the response while sending acl WhatsApp provier",
    "CN_ERROR_PROVIDER_WHATSAPP_ACL_RESPONSE_INVALID": "Invalid response from acl WhatsApp provider",
    "CN_ERROR_PROVIDER_WHATSAPP_ACL_NULL_RESPONSE": "Null response from acl WhatsApp provider",
    "CN_ERROR_PROVIDER_WHATSAPP_ACL": "Connection refused",
    "CN_USER_UNSUBSCRIBED": "Unsubscribed",
    "CN_ERROR_COMMUNICATION_CHANNEL_NULL": "Communication channel not provided.",
    "CN_ERROR_CUSTOM_TRIAL_PAUSE_NOTIFICAITON": "Custom trial, notification paused",
    "CN_ERROR_USER_ID_NULL": "User ID not found.",
    "CN_ERROR_SMS_TEMPLATE_NULL": "No SMS template is set.",
    "CN_ERROR_EMAIL_TEMPLATE_NULL": "No Email template is set.",
    "CN_ERROR_SMS_TEXT_LENGTH_EXCEED": "SMS text length exceeded.",
    "CN_ERROR_EMAIL_DYNAMIC_TEMPLATE_ID_NULL": "Email dynamic template id not found.",
    "CN_ERROR_EMAIL_DYNAMIC_TEMPLATE_NOT_FOUND": "Email dynamic template not found.",
    "CN_ERROR_SMS_DYNAMIC_TEMPLATE_NOT_FOUND": "SMS dynamic template not found.",
    "CN_ERROR_DEDUPLICATION_CONFIGURABLE_ACCOUNT_CFR_TAG_FIELDS_VALUE_MISSING_003": "CFR field value missing",
    "CN_ERROR_DEDUPLICATION_CONFIGURABLE_ACCOUNT_RESPONDED_001": "Already responded",
    "CN_ERROR_DEDUPLICATION_CONFIGURABLE_ACCOUNT_RESPONDED_002": "Already responded",
    "CN_ERROR_CONFIGURABLE_ACCOUNT_SINGLE_NOTIFICATION_001": "Single Notification",
    "CN_ERROR_DEDUPLICATION_CONFIGURABLE_ACCOUNT_TAG_FIELDS_EMPTY_002": "Tag value missing",
    "CN_ERROR_DEDUPLICATION_CONFIGURABLE_ACCOUNT_BRAND_LIST_MISSING_102": "Brand list missing in account",
    "CN_ERROR_DEDUPLICATION_CONFIGURABLE_ACCOUNT_REQUEST_COUNT_101": "Request count exceeded",
    "CN_ERROR_DEDUPLICATION_CONFIGURABLE_ACCOUNT_NOTIFICATION_COUNT_102": "Notificaion count negative",
    "CN_ERROR_DEDUPLICATION_CFR_TAG_FIELDS_VALUE_MISSING_003": "Tag value missing",
    "CN_ERROR_CONFIGURABLE_SINGLE_NOTIFICATION_001": "Single notification",
    "CN_ERROR_DEDUPLICATION_OBJECT_INVALID_001": "Invalid dedup settings",
    "CN_ERROR_PROJECTACCOUNTDEDUPLICATION_001": "Dedup exception",
    "CN_ERROR_PROJECTACCOUNTDEDUPLICATION_002": "Dedup exception",
    "CN_ERROR_PROJECTACCOUNTDEDUPLICATION_003": "Dedup exception",
    "CN_ERROR_PROJECTACCOUNTDEDUPLICATION_004": "Dedup exception",
    "CN_ERROR_DEDUPLICATION_CONFIGURABLE_SUBACCOUNT_CFR_TAG_FIELDS_VALUE_MISSING_003": "CFR_TAG_FIELDS_VALUE_MISSING",
    "CN_ERROR_DEDUPLICATION_CONFIGURABLE_SUBACCOUNT_RESPONDED_001": "Aready responded",
    "CN_ERROR_DEDUPLICATION_CONFIGURABLE_SUBACCOUNT_RESPONDED_002": "Aready responded",
    "CN_ERROR_CONFIGURABLE_SUBACCOUNT_SINGLE_NOTIFICATION_001": "Single notification",
    "CN_ERROR_DEDUPLICATION_CONFIGURABLE_SUBACCOUNT_BRAND_LIST_MISSING_102": "Brand list missing in subaccount",
    "CN_ERROR_DEDUPLICATION_CONFIGURABLE_SUBACCOUNT_NOTIFICATION_COUNT_101": "Notification count exceeded",
    "CN_ERROR_DEDUPLICATION_CONFIGURABLE_SUBACCOUNT_REQUEST_COUNT_101": "Request count exceeded",
    "CN_ERROR_DEDUPLICATION_CONFIGURABLE_SUBACCOUNT_NOTIFICATION_COUNT_102": "Notificaiton count negative",
    "CN_ERROR_DEDUPLICATION_SUBACCOUNT": "Dedup exception",
    "CN_ERROR_DEDUPLICATE_TRIAL_101": "Dedup exception",
    "CN_ERROR_DEDUPLICATION_CONFIGURABLEPROJECTACCOUNTDEDUP_ACCOUNT_NULL_101": "Account ID is null",
    "CN_ERROR_DEDUPLICATION_CONFIGURALE_ACCOUNT_TAG_FIELDS_MISSING_001": "Tag fields missing",
    "CN_ERROR_DEDUPLICATION_CONFIGURABLE_ACCOUNT_ACCOUNT_NULL_101": "Account is null",
    "CN_ERROR_DEDUPLICATION_CONFIGURABLE_SUBACCOUNT_TAG_FIELDS_EMPTY_002": "Tag field empty",
    "CN_ERROR_DEDUPLICATION_CONFIGURALE_SUBACCOUNT_TAG_FIELDS_MISSING_001": "Tag filed missing",
    "CN_ERROR_DEDUPLICATION_CONFIGURABLE_SUBACCOUNT_MISSING_101": "Sub-account id null",
    "CN_ERROR_PROVIDER_SMS_ACTIVE360_RESPONSE_NOT_AVAILABLE": "SMS provider response not available.",
    "CN_ERROR_PROVIDER_SMS_ACTIVE360_MISSING_CONFIGURATION_PARAMS": "SMS provider missing configuration params",
    "CN_ERROR_PROVIDER_SMS_ACTIVE360": "SMS provider error",
    "CN_ERROR_PROVIDER_SMS_ACTIVE360_PROVIDER_DETAILS_NOT_AVAILABLE": "SMS provider details not available",
    "CN_ERROR_PROVIDER_SMS_ACTIVE360_CAMPAIGN_NAME_NOT_AVAILABLE": "SMS provider campaign name not available",
    "CN_ERROR_PROVIDER_SMS_ACTIVE360_USERNAME_NOT_AVAILABLE": "SMS provider username not available",
    "CN_ERROR_PROVIDER_SMS_ACTIVE360_PASSWORD_NOT_AVAILABLE": "SMS provider password not available",
    "CN_ERROR_PROVIDER_SMS_ACTIVE360_TELEMARKETER_ID_NOT_AVAILABLE": "SMS provider telemarketer not available",
    "CN_ERROR_PROVIDER_SMS_ACTIVE360_ERROR_RESPONSE": "SMS provider error",
    "CN_ERROR_PROVIDER_SMS_ACTIVE360_RESPONSE_CODE_": "Email provider error",
    "CN_ERROR_PROVIDER_EMAIL_ACL_RESPONSE_CODE": "Email provider error",
    "CN_ERROR_PROVIDER_EMAIL_ACL_RESPONSE_INVALID": "Email provider invalid response",
    "CN_ERROR_PROVIDER_EMAIL_ACL_URL_NULL": "Email provider url not found",
    "CN_ERROR_PROVIDER_EMAIL_ACL_MISSING_CONFIGURATION_PARAMS": "Email provider missing configuration parameters",
    "CN_ERROR_PROVIDER_EMAIL_ACL_MISSING_PROVIDER_CONFIGURATION": "Email provider missing provider configuration",
    "CN_ERROR_PROVIDER_EMAIL_ACL_EMAIL_ADDRESS_NULL": "Email provider missing email address",
    "CN_ERROR_PROVIDER_EMAIL_ACL": "Email provider error",
    "CN_ERROR_PROVIDER_EMAIL_NETCORE_RESPONSE_CODE": "Email provider error",
    "CN_ERROR_PROVIDER_EMAIL_NETCORE_RESPONSE_INVALID": "Email provider invalid response",
    "CN_ERROR_PROVIDER_EMAIL_NETCORE_URL_NULL": "Email provider url not found",
    "CN_ERROR_PROVIDER_EMAIL_NETCORE_MISSING_CONFIGURATION_PARAMS": "Email provider missing configuration parameters",
    "CN_ERROR_PROVIDER_EMAIL_NETCORE_MISSING_PROVIDER_CONFIGURATION": "Email provider missing provider configuration",
    "CN_ERROR_PROVIDER_EMAIL_NETCORE_EMAIL_ADDRESS_NULL": "Email provider email address not found",
    "CN_ERROR_PROVIDER_EMAIL_NETCORE": "Email provider error",
    "CN_ERROR_PROVIDER_SMS_DELIVERYSTATUS_NOT_SUCCESS": "SMS provider delivery failed",
    "CN_ERROR_PROVIDER_SMS_HOME_CREDIT_RESPONSE_NULL": "SMS provider error response empty",
    "CN_ERROR_PROVIDER_SMS_HOME_CREDIT": "SMS provider error",
    "CN_ERROR_PROVIDER_SMS_HOME_CREDIT_RESPONSE_CODE": "SMS provider error response code",
    "CN_ERROR_PROVIDER_SMS_ICUBES_RESPONSE_CODE_": "SMS provider error response code",
    "CN_ERROR_PROVIDER_SMS_KALEYRA_STATUS_CODE": "SMS provider error status code",
    "CN_ERROR_PROVIDER_SMS_KALEYRA_NULL_RESPONSE": "SMS provider error empty response",
    "CN_ERROR_PROVIDER_SMS_KALEYRA": "SMS provider error",
    "CN_ERROR_PROVIDER_SMS_Kaleyra_": "SMS provider error",
    "CN_ERROR_PROVIDER_EMAIL_MAILGUN_RESPONSE_CODE": "Email provider error response code",
    "CN_ERROR_PROVIDER_EMAIL_MAILGUN_RESPONSE_ERROR": "Email provider response error",
    "CN_ERROR_PROVIDER_EMAIL_MAILGUN_RESPONSE_NULL": "Email provider empty response",
    "CN_ERROR_PROVIDER_EMAIL_PHONON_RESPONSE_NOT_AVAILABLE": "Email provider response not available",
    "CN_ERROR_PROVIDER_EMAIL_PHONON_RESPONSE_CODE_NOT_AVAILABLE": "Email provider response code not available",
    "CN_ERROR_PROVIDER_EMAIL_PHONON_RESPONSE_CODE_NOT_200": "Email provider response code not 200",
    "CN_ERROR_PROVIDER_EMAIL_PHONON_EMAIL_URL_NULL": "Email provider error url empty",
    "CN_ERROR_PROVIDER_EMAIL_PHONON_EMAIL_ADDRESS_NULL": "Email provider email address not found",
    "CN_ERROR_PROVIDER_SMS_PHONON_RESPONSE_NOT_AVAILABLE": "SMS provider response not available.",
    "CN_ERROR_PROVIDER_SMS_PHONON_MISSING_CONFIGURATION_PARAMS": "SMS provider missing configuration parameters",
    "CN_ERROR_PROVIDER_SMS_PHONON": "SMS provider error",
    "CN_ERROR_PROVIDER_SMS_PHONON_SECURITY_ID_NOT_AVAILABLE": "SMS provider security id not available",
    "CN_ERROR_PROVIDER_SMS_PHONON_FLOW_ID_NOT_AVAILABLE": "SMS provider flow id not available",
    "CN_ERROR_PROVIDER_SMS_PHONON_MISSING_CONFIGURATION_PARAMS_USERNAME_PASSWORLD_FIELD": "SMS provider missing configuration parameters",
    "CN_ERROR_PROVIDER_SMS_PHONON_ERROR_RESPONSE_CODE_NOT_200": "SMS provider response code not 200",
    "CN_ERROR_PROVIDER_SMS_PHONON_MISSING_RESPONSE_CODE_FIELD": "SMS provider missing response code",
    "CN_ERROR_PROVIDER_EMAIL_PINPOINT_PROJECTID_NOT_AVAILABLE": "Email provider project information not available",
    "CN_ERROR_PROVIDER_EMAIL_PINPOINT_FROM_ADDRESS_NOT_AVAILABLE": "Email provider address not available",
    "CN_ERROR_PROVIDER_EMAIL_DELIVERYSTATUS_NOT_SUCCESS": "Email provider delivery not successful",
    "CN_ERROR_PROVIDER_EMAIL_PINPOINT_STATUS_NOT_200": "Email provider status not 200",
    "CN_ERROR_PROVIDER_EMAIL_PINPOINT_RESPONSE_EMAIL_NOT_AVAILABLE": "Email provider response email not available",
    "CN_ERROR_PROVIDER_EMAIL_PINPOINT_RESULT_NOT_AVAILABLE": "Email provider result not available",
    "CN_ERROR_PROVIDER_EMAIL_PINPOINT_RESPONSE_IS_NULL": "Email provider response is empty",
    "CN_ERROR_PROVIDER_EMAIL_PINPOINT_CONFIG_NOT_AVAILABLE": "Email provider configuration is not available",
    "CN_ERROR_PROVIDER_EMAIL_PINPOINT_EMAIL_NOT_AVAILABLE": "Email provider email not available",
    "CN_ERROR_PROVIDER_SMS_PINPOINT_PROJECTID_NOT_AVAILABLE": "SMS provider project id not available",
    "CN_ERROR_PROVIDER_SMS_PINPOINT_STATUS_NOT_200": "SMS provider status not 200",
    "CN_ERROR_PROVIDER_SMS_PINPOINT_RESPONSE_PHONENUMBER_NOT_AVAILABLE": "SMS provider response phone number not available",
    "CN_ERROR_PROVIDER_SMS_PINPOINT_RESULT_NOT_AVAILABLE": "SMS provider result not available",
    "CN_ERROR_PROVIDER_SMS_PINPOINT_RESPONSE_NOT_AVAILABLE": "SMS provider response not available.",
    "CN_ERROR_PROVIDER_SMS_PINPOINT": "SMS provider error",
    "CN_ERROR_PROVIDER_EMAIL_DELIVERY_STATUS_NOT_SUCCESS": "Email provider status not success",
    "CN_ERROR_PROVIDER_EMAIL_ADOBE_TITAN_EMAIL_ADDRESS_NULL": "Email provider email address not found",
    "CN_ERROR_PROVIDER_SMS_TVS_URL_IS_NULL_OR_EMPTY": "SMS provider url is empty",
    "CN_ERROR_PROVIDER_SMS_TVS_BASICDBOBJECT_IS_NULL": "SMS provider details not available",
    "CN_ERROR_PROVIDER_SMS_TVS_ENTITY_ID_OR_TEMPLATE_ID_IS_NOT_PRESENT": "SMS provider entity or template id is not present",
    "CN_ERROR_PROVIDER_SMS_TVS_SMS_PROVIDER_OBJECT_NOT_FOUND": "SMS provider object not found",
    "CN_ERROR_PROVIDER_SMS_TVS_DLT_PARAMETERS_NOT_FOUND": "SMS provider parameters not found",
    "CN_ERROR_PROVIDER_SMS_TVS_DLT_PARAMETERS_FIELD_NAME_NOT_FOUND": "SMS provider parameters field name not found",
    "CN_ERROR_PROVIDER_SMS_TVS_RESPONSE_NULL": "SMS provider empty response",
    "CN_ERROR_PROVIDER_SMS_TVS_RESPONSE_INVALID": "SMS provider invalid response",
    "CN_ERROR_PROVIDER_SMS_TVS": "SMS provider error",
    "CN_ERROR_PROVIDER_WHATSAPP_GUPSHUP_URL_NULL": "WhatsApp provider url is empty",
    "CN_ERROR_PROVIDER_WHATSAPP_GUPSHUP_RESPONSE_ERROR": "WhatsApp provider error response",
    "CN_ERROR_PROVIDER_WHATSAPP_GUPSHUP_RESPONSE_ID_EMPTY": "WhatsApp provider response id empty",
    "CN_ERROR_PROVIDER_WHATSAPP_GUPSHUP_RESPONSE_OBJECT": "WhatsApp provider response object not valid",
    "CN_ERROR_PROVIDER_WHATSAPP_GUPSHUP_NULL_RESPONSE": "WhatsApp provider empty response",
    "CN_ERROR_PROVIDER_WHATSAPP_GUPSHUP": "WhatsApp provider error",
    "CN_ERROR_PROVIDER_WHATSAPP_GUPSHUP_IOEXCEPTION": "WhatsApp provider IO Exception",
    1: "Request Delivered",
    2: "Request Undelivered",
    3: "Request Expired",
    4: "Request Status Unknown",
    5: "Request Deleted",
    6: "Request Rejected",
    7: "Request Delivery Pending",
    8: "Customer has DND enabled"
  };
  readonly getErrorDescription = OutboxDetailPanelComponent.getErrorDescription;
}
